/**
 * The longest span, in days, that the workshop range endpoints serve in one
 * request. The calendar's List view asks for exactly this much, so the two
 * sides read it from here rather than each holding their own copy (BON-565).
 */
export const WORKSHOP_RANGE_MAX_DAYS = 100;
